import debug from 'debug';

import * as authTypes from '../actions/auth.types';

const log = debug('huddle:store:reducers:auth');

const INITIAL_STATE = {
  error: null,
  loading: false,
  credentials: {
    uname: '',
    password: '',
  },
  user: { },
  loggedIn: false,
  referrerURL: '',
};

function loggingIn(state) {
  return {
    ...state,
    loading: true,
  };
}

function resetInitialState(state) {
  return { ...state,
    error: null,
    loading: false,
    credentials: {},
  };
}

function authError(state, error, { uname, password }) {
  return {
    ...state,
    loading: false,
    error,
    credentials: {
      uname,
      password,
    },
  };
}

function loggedIn(state, { user }) {
  return {
    ...state,
    error: null,
    loading: false,
    credentials: {
      uname: '',
      password: '',
    },
    user,
    loggedIn: true,
  };
}

function loggingOut(state) {
  return {
    ...state,
    error: null,
    loading: true,
  };
}

function loggedOut(state) {
  return {
    ...state,
    error: null,
    loading: false,
    loggedIn: false,
    user: { },
  };
}

export default function authReducer(state = INITIAL_STATE, action = {}) {
  const { type, error, payload } = action;
  switch (type) {
    case authTypes.RESET_AUTH_STATE:
      return resetInitialState(state);
    case authTypes.LOGGING_IN:
      return loggingIn(state);
    case authTypes.LOGGED_IN:
      return loggedIn(state, payload);
    case authTypes.LOGGING_OUT:
      return loggingOut(state);
    case authTypes.LOGGED_OUT:
      return loggedOut(state);
    case authTypes.AUTH_ERROR:
      return authError(state, error, payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js